// extracted by mini-css-extract-plugin
export var md = "_2j-4";
export var semantic = "_2j-5";
export var sm = "_2j-3";
export var text = "_2j-6";
export var toggleInput = "_2j-0";
export var toggleSwitch = "_2j-1";
export var xs = "_2j-2";